export const GET_INVOICES_LIST = "GET_INVOICES_LIST"
export const GET_INVOICES_LIST_SUCCESS = "GET_INVOICES_LIST_SUCCESS"
export const GET_INVOICES_LIST_ERROR = "GET_INVOICES_LIST_ERROR"
